import { $voixFetch } from "#imports";
import { useAdminStore } from "@voix/store/adminStore";
import { usePagesStore } from "@voix/store/pagesStore";
import { $voixNuxtApi } from "@voix/voix-layer/composables/voixNuxtApi";
import { useVoixToast } from "../useVoixToast.js";
function setPagesInStore(response) {
  if (response) {
    const pagesStore = usePagesStore();
    pagesStore.setPages(response);
  }
}
async function getPages(variables) {
  const adminStore = useAdminStore();
  adminStore.isLoading = true;
  const filters = JSON.parse(variables.filter);
  filters.language_code = { field: "language_code", op: "=", value: variables.language_code, clause: "where" };
  variables.filter = JSON.stringify(filters);
  if (variables.orderBy && Object.keys(variables.orderBy).length) {
    variables.orderBy = variables.orderBy.map((orderBy) => {
      const ob = JSON.parse(JSON.stringify(orderBy));
      return `${ob.column}:${ob.order}`;
    });
  } else {
    variables.orderBy = "";
  }
  const query = new URLSearchParams(variables).toString();
  const request = await $voixNuxtApi(
    `/api/admin/voix/pages?${query.toString()}`
  );
  setPagesInStore(request.data.value);
  adminStore.isLoading = false;
  return request;
}
async function getPageReleases(variables) {
  const adminStore = useAdminStore();
  adminStore.isLoading = true;
  const filters = JSON.parse(variables.filter);
  filters.language_code = { field: "language_code", op: "=", value: variables.language_code, clause: "where" };
  variables.filter = JSON.stringify(filters);
  if (variables.orderBy && Object.keys(variables.orderBy).length) {
    variables.orderBy = variables.orderBy.map((orderBy) => {
      const ob = JSON.parse(JSON.stringify(orderBy));
      return `${ob.column}:${ob.order}`;
    });
  } else {
    variables.orderBy = "";
  }
  const query = new URLSearchParams(variables).toString();
  const request = await $voixFetch(
    `/api/admin/voix/page-releases?${query.toString()}`
  );
  adminStore.isLoading = false;
  return request;
}
async function createPage(variables) {
  const adminStore = useAdminStore();
  const voixToast = useVoixToast();
  adminStore.isLoading = true;
  const request = await $voixNuxtApi(
    `/api/admin/voix/pages`,
    {
      method: "POST",
      body: variables
    }
  );
  adminStore.isLoading = false;
  if (request.data.value) {
    voixToast.add(`Page Created: ${variables.title}`, "msg");
    return request;
  } else {
    throw new Error("Unable to save");
  }
}
async function copyPage(pageData) {
  const adminStore = useAdminStore();
  adminStore.isLoading = true;
  const request = await $voixNuxtApi(
    `/api/admin/voix/page-copies`,
    {
      method: "POST",
      body: pageData
    }
  );
  adminStore.isLoading = false;
  return request;
}
async function translatePage(pageData) {
  const adminStore = useAdminStore();
  adminStore.isLoading = true;
  const request = await $voixNuxtApi(
    `/api/admin/voix/page-localizations`,
    {
      method: "POST",
      body: pageData
    }
  );
  adminStore.isLoading = false;
  return request;
}
export { copyPage, createPage, getPageReleases, getPages, translatePage };
